<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6">
      <app-bs-display
        *ngIf="isVerified"
        key="UserProfile.NameAr"
        [valueText]="form.controls.NameAr.value"
      >
      </app-bs-display>
      <bs-ng-text
        *ngIf="!isVerified"
        formControlName="NameAr"
        identifier="NameAr"
        name="NameAr"
        key="UserProfile.NameAr"
        maxLength="200"
      >
      </bs-ng-text>
    </div>

    <div class="col-md-6">
      <app-bs-display
        *ngIf="isVerified"
        key="UserProfile.NameEn"
        [valueText]="form.controls.NameEn.value"
      >
      </app-bs-display>
      <bs-ng-text
        *ngIf="!isVerified"
        formControlName="NameEn"
        identifier="NameEn"
        name="NameEn"
        key="UserProfile.NameEn"
        maxLength="200"
      >
      </bs-ng-text>
    </div>

    <div class="col-md-6">
      <app-bs-display
        *ngIf="isVerified && formTemp?.Nationality"
        key="UserProfile.Nationality"
        [valueText]="form.controls.Nationality.value | lookup : lang"
      >
      </app-bs-display>
      <bs-ng-dropdown
        *ngIf="!isVerified || !formTemp?.Nationality"
        formControlName="Nationality"
        identifier="Nationality"
        name="Nationality"
        key="UserProfile.Nationality"
        [items]="lookups.Countries"
        [bindLabel]="defaultLookupDisplayProperty"
      >
      </bs-ng-dropdown>
    </div>

    <div class="col-md-6">
      <app-bs-display
        *ngIf="isVerified && formTemp?.ResidencyType"
        key="UserProfile.ResidencyType"
        [valueText]="form.controls.ResidencyType.value | lookup : lang"
      >
      </app-bs-display>
      <bs-ng-dropdown
        *ngIf="!isVerified || !formTemp?.ResidencyType"
        formControlName="ResidencyType"
        identifier="ResidencyType"
        name="ResidencyType"
        key="UserProfile.ResidencyType"
        [items]="lookups.ResidencyTypes"
        [bindLabel]="defaultLookupDisplayProperty"
      >
      </bs-ng-dropdown>
    </div>

    <div class="col-md-6" *ngIf="form?.controls?.ResidencyType?.value?.code != 'Other'">
      <app-bs-display
        *ngIf="isVerified && formTemp?.IdNumber"
        key="UserProfile.IdNumber"
        [valueText]="form.controls.IdNumber.value"
      >
      </app-bs-display>
      <bs-ng-text
        *ngIf="!isVerified || !formTemp?.IdNumber"
        formControlName="IdNumber"
        identifier="IdNumber"
        name="IdNumber"
        key="UserProfile.IdNumber"
        [prefix]="emiratesIdMaskPrefix"
        [mask]="emiratesIdMask"
        maxLength="50"
      >
      </bs-ng-text>
    </div>

    <div class="col-md-6" *ngIf="form?.controls?.ResidencyType?.value?.code == 'Other'">
      <app-bs-display
        *ngIf="isVerified && formTemp?.Passport"
        key="UserProfile.Passport"
        [valueText]="form.controls.Passport.value"
      >
      </app-bs-display>
      <bs-ng-text
        *ngIf="!isVerified || !formTemp?.Passport"
        formControlName="Passport"
        identifier="Passport"
        name="Passport"
        key="UserProfile.Passport"
        maxLength="50"
      >
      </bs-ng-text>
    </div>

    <div class="col-md-6">
      <app-bs-display
        *ngIf="isVerified && formTemp?.Gender"
        key="UserProfile.Gender"
        [valueText]="form.controls.Gender.value | lookup : lang"
      >
      </app-bs-display>
      <div class="form-group" *ngIf="!isVerified || !formTemp?.Gender">
        <label class="form-control-label-required">{{
          ('UserProfile.Gender' | translate).labelText
        }}</label>
        <div class="row">
          <div *ngFor="let type of lookups.Genders" class="col-md-3">
            <bs-ng-radiobox
              formControlName="Gender"
              identifier="GenderM"
              [key]="'UserProfile.Gender.' + type.code"
              name="Gender"
              [set]="type"
            >
            </bs-ng-radiobox>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group">
        <label class="form-control-label-required">{{
          ('UserProfile.HasDisability' | translate).labelText
        }}</label>
        <div class="row">
          <div class="col-md-3">
            <bs-ng-radiobox
              formControlName="HasDisability"
              identifier="HasDisabilityY"
              key="UserProfile.HasDisability.Yes"
              name="HasDisability"
              [set]="true"
              (change)="onHasDisabilityChange()"
            >
            </bs-ng-radiobox>
          </div>
          <div class="col-md-3">
            <bs-ng-radiobox
              formControlName="HasDisability"
              identifier="HasDisabilityN"
              key="UserProfile.HasDisability.No"
              name="HasDisability"
              [set]="false"
              (change)="onHasDisabilityChange()"
            >
            </bs-ng-radiobox>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6" *ngIf="form?.controls?.HasDisability?.value">
      <bs-ng-dropdown
        formControlName="Disabilities"
        identifier="Disabilities"
        key="UserProfile.Disabilities"
        name="Disabilities"
        [items]="lookups.Disabilities"
        [bindLabel]="defaultLookupDisplayProperty"
        [searchable]="true"
        [multiple]="true"
        [closeOnSelect]="false"
      >
      </bs-ng-dropdown>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-date
          formControlName="BirthDate"
          identifier="BirthDate"
          key="UserProfile.BirthDate"
          name="BirthDate"
        >
        </bs-ng-date>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-dropdown
        formControlName="Job"
        identifier="Job"
        name="Job"
        key="UserProfile.Job"
        [items]="lookups.Jobs"
        [bindLabel]="defaultLookupDisplayProperty"
      >
      </bs-ng-dropdown>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-dropdown
        formControlName="MaritalStatus"
        identifier="MaritalStatus"
        name="MaritalStatus"
        key="UserProfile.MaritalStatus"
        [items]="lookups.MaritalStatuses"
        [bindLabel]="defaultLookupDisplayProperty"
      >
      </bs-ng-dropdown>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-number
            formControlName="FamilyMembersNumber"
            identifier="FamilyMembersNumber"
            key="UserProfile.FamilyMembersNumber"
            name="FamilyMembersNumber">
        </bs-ng-number>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-number
            formControlName="TotalIncome"
            identifier="TotalIncome"
            key="UserProfile.TotalIncome"
            name="TotalIncome">
        </bs-ng-number>
    </div>
  </div>
</form>
